/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConnectAccessUrlResponseContent
 */
export interface GetConnectAccessUrlResponseContent {
    /**
     * 
     * @type {string}
     * @memberof GetConnectAccessUrlResponseContent
     */
    url?: string;
}


/**
 * Check if a given object implements the GetConnectAccessUrlResponseContent interface.
 */
export function instanceOfGetConnectAccessUrlResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetConnectAccessUrlResponseContentFromJSON(json: any): GetConnectAccessUrlResponseContent {
    return GetConnectAccessUrlResponseContentFromJSONTyped(json, false);
}

export function GetConnectAccessUrlResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConnectAccessUrlResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function GetConnectAccessUrlResponseContentToJSON(value?: GetConnectAccessUrlResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

